<template>
  <div class="col-12 quick-v-attr-select">
    <span class="attr-title">
          {{ variationGroup.variationGroupName }}
        </span>
    <div class="attr-prop">
      <div class="attr-select-in" v-show="getSelectedText.length > 0">
        {{ getSelectedText }}
      </div>
      <button
        v-for="variationEntry in getVariationEntriesOfThisGroupFromVariationGroupData"
        :key="variationEntry.variationId"
        class="attr-btn-color"
        v-on:click="navigateToProduct(variationEntry.variationId)"
        :style="'background:'+ variationEntry.variationDisplayValue">
        <span><i :class="defaultValue === variationEntry.variationName ? 'lni lni-checkmark' : 'lni'"></i></span>
      </button>
    </div>
  </div>

</template>

<script>
import variationSelectorMixin from './VariationSelectorMixin'

export default {
  name: 'VariationHexSelector',
  mixins: [variationSelectorMixin],
  data () {
    return {
      version: '0.0.2'
    }
  }
}
</script>
